import React from "react";
import { PageContainer } from "@components";
import { QueryStateIndicators } from "../../components/QueryStateIndicators";
import { User } from "@models";
import ModuleSettingsList from "./components/ModuleSettingsList";
import ProductsPageContext from "./ProductsPageContext";
import { useModuleSettings } from "@hooks";

type Props = {
	user: User;
};

export default function ProductsPage(props: Props) {
	const { user } = props;
	const [moduleSettingsQuery, refreshModuleSettings] = useModuleSettings(
		user.userId
	);
	const moduleSettings = moduleSettingsQuery.data;

	return (
		<PageContainer>
			<QueryStateIndicators queryState={moduleSettingsQuery} />
			{!!moduleSettings && (
				<ProductsPageContext.Provider
					value={{
						moduleSettings: moduleSettings,
						triggerRefresh: refreshModuleSettings,
					}}
				>
					<ModuleSettingsList moduleSettings={moduleSettings} />
				</ProductsPageContext.Provider>
			)}
		</PageContainer>
	);
}
